import {NgModule} from '@angular/core';
import {HmConfigPage} from "./page/overview/hc-config/hm-config.page";
import {HM_ENTITY_PROVIDER} from "./hm.entity-provider";
import {CoreModule} from "../../core/core.module";
import {HM_TEST_PROVIDERS} from "./test/hm-test-definition";


@NgModule({
  declarations: [
    HmConfigPage
  ],
  exports:[
    HmConfigPage
  ],
  imports: [
    CoreModule,
  ],
  providers: [HM_ENTITY_PROVIDER, HM_TEST_PROVIDERS]
})
export class HmModule { }
 
 
 
